<template>
  <md-card style="background-color: white; max-height: 75vh; overflow-y: auto; border-radius: 8px">
    <md-card-content>
      <b-row style="border-bottom:1px solid #b3b3b3; margin-bottom: 8px; margin-top: 10px">
        <b-col>
          <p style="color: #525252; font-size: 20px"><b>Filter</b></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-list dense>
            <div v-for="(field, index) in orderedProperties" :key="field.id">
              <v-list-item style="margin-bottom: 6px">
                <v-select
                    v-if="field.property_type === 'auto_complete'"
                    :hint="field.description"
                    persistent-hint
                    :items="getSelects(field.auto_complete_options || [])"
                    :label="field.name"
                    v-model="editEnity.properties[field.id]"
                    :prepend-inner-icon="getIcon(field.comparator)"
                >
                  <template #append-outer>
                    <v-icon color="red" @click="deleteFilter(field.id)">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-select>
                <v-text-field v-else-if="field.property_type === 'string' || field.property_type === 'integer' || field.property_type === 'float'"
                              :label="field.name"
                              :hint="field.description"
                              persistent-hint
                              v-model="editEnity.properties[field.id]"
                              :prepend-inner-icon="getIcon(field.comparator)"
                >
                  <template #append-outer>
                    <v-icon color="red" @click="deleteFilter(field.id)">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-text-field>
                <v-menu
                    v-else-if="field.property_type === 'date'"
                    :ref="field.id + 'date'"
                    v-model="field.show"
                    :close-on-content-click="false"
                    :return-value.sync="editEnity.properties[field.id]"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formatDate(editEnity.properties[field.id])"
                        :label="field.name"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :hint="field.description"
                        persistent-hint
                        :prepend-inner-icon="getIcon(field.comparator)"
                    >
                      <template #append-outer>
                        <v-icon color="red" @click="deleteFilter(field.id)">
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="editEnity.properties[field.id]"
                      no-title
                      scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="field.show = false"
                    >
                      Abbrechen
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs[field.id + 'date'][0].save(editEnity.properties[field.id])"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <v-select
                    v-else-if="field.property_type === 'boolean'"
                    :hint="field.description"
                    persistent-hint
                    :items="boolSelects"
                    :label="field.name"
                    v-model="editEnity.properties[field.id]"
                    :prepend-inner-icon="getIcon(field.comparator)"
                >
                  <template #append-outer>
                    <v-icon color="red" @click="deleteFilter(field.id)">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-select>
                <v-select
                    v-else-if="field.property_type === 'select'"
                    :hint="field.description"
                    persistent-hint
                    :items="getSelects(field.auto_complete_options || [])"
                    :label="field.name"
                    v-model="editEnity.properties[field.id]"
                    :prepend-inner-icon="getIcon(field.comparator)"
                >
                  <template #append-outer>
                    <v-icon color="red" @click="deleteFilter(field.id)">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-select>
              </v-list-item>
            </div>
            <v-list-item>
              <v-btn
                  block
                  color="primary"
                  elevation="2"
                  small
                  @click="$refs.add_filter_dialog.showDialog()"
              ><v-icon left>
                mdi-plus
              </v-icon>
                Filter hinzufügen</v-btn>
            </v-list-item>
            <v-list-item style="margin-top: 6px">
              <!--v-spacer></v-spacer-->
              <v-spacer></v-spacer>
              <v-btn
                  elevation="2"
                  rounded
                  color="success"
                  style="z-index: 200; margin-right: 0px; margin-top: 8px"
                  class="text-none"
                  @click="setFilter"
              >Anwenden</v-btn>
            </v-list-item>
          </v-list>
        </b-col>
      </b-row>
    </md-card-content>
    <add-filter-dialog ref="add_filter_dialog" :definition="definition" @add-filter="addFilter"></add-filter-dialog>
  </md-card>
</template>

<script>

import AddFilterDialog from "@/views/cadastre/AddFilterDialog.vue";
export default {
  name: "CadastreFilter",
  components: {
    AddFilterDialog
  },
  props: {
    definition: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          category: '',
          description: '',
          properties: [],
          properties_order: [],
        }
      }
    },
  },
  data: () => {
    return {
      editEnity: {
        properties: {},
      },
      orderedProperties: [],
      boolSelects: [
        { text: 'Nicht gesetzt', value: null },
        { text: 'Ja', value: true },
        { text: 'Nein', value: false }
      ],
    }
  },
  watch: {
    definition: {
      handler(newValue) {
        this.$nextTick(() => {
          /*if (newValue && newValue.id) {
            this.setEntity();
          } else {*/
            this.editEnity = {
              properties: {},
            };
            this.orderedProperties = [];
          //}
        });
      },
      immediate: true,
    },
  },
  methods: {
    deleteFilter(id) {
      this.editEnity.properties[id] = '';
      this.orderedProperties = this.orderedProperties.filter(prop => prop.id !== id);
    },
    getIcon(comparator) {
      switch (comparator) {
        case "==":
          return "mdi-equal";
        case "!=":
          return "mdi-not-equal-variant";
        case "<":
          return "mdi-less-than";
        case ">":
          return "mdi-greater-than";
      }
      return ""
    },
    getSelects(autos) {
      return [
        { text: 'Nicht gesetzt', value: '' },
        ...autos.map(auto => ({ text: auto, value: auto }))
      ];
    },
    addFilter({id, value, property}) {
      console.log('id', id, 'value', value, 'property', property)
      console.log(this.editEnity.properties)
      console.log(this.orderedProperties)
      this.editEnity.properties[id] = value;
      this.orderedProperties.push({...property});
      console.log(this.editEnity)
      console.log(this.orderedProperties)
    },
    setEntity() {
      let entity = {
        properties: {}
      };
      let orderedProperties = [];
      for (let i = 0; i < this.definition.properties_order.length; i++) {
        let key = this.definition.properties_order[i];
        let property = this.definition.properties.find(p => p.key === key);
        if (property) {
          property.show = false;
          orderedProperties[i] = property;
          if (!entity.properties[key]) {
            entity.properties[key] = '';
            if (property.property_type === 'boolean') {
              entity.properties[key] = null;
            } else if (property.property_type === 'integer') {
              entity.properties[key] = '';
            } else if (property.property_type === 'float') {
              entity.properties[key] = '';
            }
          }
        }
      }
      this.editEnity = entity;
      this.orderedProperties = orderedProperties;
      this.$nextTick(() => {
        console.log(this.editEnity)
        console.log(this.orderedProperties)
      });
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
    setFilter() {
      let activeFilter = [];
      for (let i = 0; i < this.orderedProperties.length; i++) {
        let prop = this.orderedProperties[i];
        if (this.editEnity.properties[prop.id] !== ''
            && this.editEnity.properties[prop.id] !== null
            && this.editEnity.properties[prop.id] !== undefined) {
          let filter = {
            comparator: prop.comparator,
            property: prop.key,
            value: this.editEnity.properties[prop.id]
          };
          if (prop.property_type === 'integer') {
            let value = filter.value.replace(/\./g, '');
            try {
              filter.value = parseInt(value, 10);
            } catch (e) {
              console.log(e)
            }
          } else if (prop.property_type === 'float') {
            let value = filter.value.replace(/\./g, '').replace(',', '.');
            try {
              filter.value = parseFloat(value);
            } catch (e) {
              console.log(e)
            }
          } else if (prop.property_type === 'boolean' && (filter.comparator === '<' || filter.comparator === '>')) {
            // boolean properties cannot be compared with < or >
            continue
          }
          activeFilter.push(filter);
        }
      }
      this.$emit('filter', activeFilter);
    }
  }
}
</script>

<style scoped>

</style>
